import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useAppSelector } from '../../data/store'
import { creditApplicationSelectors } from '../../data/store/CreditApplicationStore'

function CreditApplicationCancelled() {
  const navigate = useNavigate()
  const { t } = useTranslation()
  const currentMerchantId = useAppSelector(creditApplicationSelectors.getCurrentMerchantId)

  return (
    <main className="general-message">
      <h4 className="subtitle">{t<string>('common.financeApplication')}</h4>
      <h1>{t<string>('common.cancelled')}</h1>
      <button
        type="button"
        className="btn btn-blue"
        onClick={() => {
          navigate(`/${currentMerchantId}`, { replace: true })
        }}
      >
        <span> {t<string>('common.newApplication')}</span>
        <i className="fa-regular fa-paper-plane-top" />
      </button>
    </main>
  )
}

export default CreditApplicationCancelled
